import { render } from "./MainTab.vue?vue&type=template&id=5f0ae60a&scoped=true"
import script from "./MainTab.vue?vue&type=script&lang=js"
export * from "./MainTab.vue?vue&type=script&lang=js"

import "./MainTab.vue?vue&type=style&index=0&id=5f0ae60a&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0ae60a"]])

export default __exports__